import React, { useState } from 'react';
import bem from 'utils/bem';
import { toast } from 'react-hot-toast';
import Text from 'components/Text';
import Icon from 'components/Icon';
import { Button } from 'components/Button';
import Model from '../../../../model';
import './index.sass'

const { block, el } = bem('cancel-form', 'form');

const CancelForm = ({refundSum, ticketId, orderId, meetingType}) => {

    const [ isSubmitting, setIsSubmitting ] = useState(false);
    const { openCancelForm, closeCancelForm } = Model.modal;

    const handleSubmit = () => {
        const formData = new FormData();

        if (ticketId) {
            formData.append('ticket_id', ticketId);
            if (refundSum) {
                formData.append('refund_sum', refundSum);
            }
        } else {
            formData.append('order_id', orderId);
        }

        setIsSubmitting(true);
        const deleteUrl = ticketId ? '/ticket/delete' : '/order/delete';

        fetch(deleteUrl, {
            method: 'POST',
            body: formData
        }).then((promise) => {
            return promise.json();
        }).then((response) => {
            if (response.success) {
                setIsSubmitting(false);
                window.location = '/orders';
                toast.success(`Вы успешно удалили запись`);
            } else if (response.need_confirmation) {
                // closeModal();
                setIsSubmitting(false);
                openCancelForm({
                    ticketId,
                    meetingType,
                    refundSum: response.refund_sum
                });
            }
            else {
                const error = response?.error;
                if (error === 'refund amount is different')
                    toast.error(`Произошла ошибка, попробуйте отменить запись еще раз`);
                if (error === 'too_late')
                    toast.error(`Вы пытаетесь отменить запись менее чем за ${meetingType === 'OFF' ? '24 часа' : '12 часов'} до ее начала, а это невозможно`);
                if (error === 'no_for_ticket')
                    toast.error(`Отмена абонементов запрещена, обратитесь к администратору`);
                if (error === 'unpaid')
                    toast.error(`Действие не разрешено для неоплаченной записи`);
                if (error === 'unknown')
                    toast.error(`Произошла неизвестная ошибка, обратитесь к администратору`);
                closeCancelForm();
            }
        }).catch(err => {
            toast.error(`Произошла ошибка ${err}, обратитесь к администратору`);
            closeCancelForm();

        });
    };

    return (
        <div className={block()}>
            <div className={el('smiley')}>
                <Icon name={'warning-circle'} />
            </div>
            <div className={el('text-block')}>
                {refundSum
                    ? <Text serif>Подтвердите возврат средств в размере {refundSum} руб.</Text>
                    : <Text serif>Вы уверены, что хотите отменить запись?</Text>
                }
            </div>
            <div className={el('buttons')}>
                <Button mod='gold' className={el('button','yes')} onClick={handleSubmit} disabled={isSubmitting}>
                    <Text>Да</Text>
                </Button>
                <Button mod='transparent-gold' className={el('button', 'no')} onClick={closeCancelForm}>
                    <Text>Нет</Text>
                </Button>
            </div>
        </div>
    )

};

export default CancelForm;
